import { createStore } from '@stencil/store';

import type { NotificationContent, NotificationMode, Layout } from './types';
import type { HighlightableElement } from '../acquisition-overlay/components/clickable-element';

export type NotificationState = {
  mode: NotificationMode;
  account: string;
  overlayId: string;
  content: NotificationContent;
  layout: Layout | Record<string, never>;
  preventHighlight: boolean;
  isMobileViewport: boolean;
  highlightElement: HighlightableElement | null;
  shadowRoot: ShadowRoot;
};

const { state, on, ...rest } = createStore<NotificationState>(() => ({
  mode: 'live',
  content: null,
  layout: { name: 'default' },
  account: null,
  overlayId: null,
  preventHighlight: false,
  isMobileViewport: false,
  highlightElement: null,
  shadowRoot: null,
}));

export default state;
export const store = { on, ...rest };
